'use strict';

module.exports = {
  LINE_BREAK_SYMBOL: '\u000A',
};
